<template>
  <div
    data-layout="site/public"
    class="
      bg-neutral-200 font-display
      font-normal text-primal
    "
  >
    <div class="mx-auto">
      <slot />
    </div>
  </div>
</template>
